
// 共通类
let CommonUtil = {};


/**
 * 将对象解析为Get方法所用的参数
 * @param 对象参数
 */
CommonUtil.analyticParameter = function (o) {
  let params = '';
  let firstParams = true;
  for (let x in o) {
    if (firstParams) {
      firstParams = false;
      params = `${params}?${x}=${o[x]}`;
    } else {
      params = `${params}&${x}=${o[x]}`;
    }
  }
  return params;
};


export default CommonUtil;
